import { RootState } from '../../store/rootReducer';
import { ErrorState } from '../types';

export const getErrorHandlerState = (state: RootState): ErrorState => {
  return state.errorHandler;
};
